import axios from "axios";
import { profileStore } from "@/lib/profileStore";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "vaw_token";

export const tokenStore = {
  get: () => {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch (_e) {
      return null;
    }
  },
  set: (t) => {
    try {
      localStorage.setItem(TOKEN_KEY, t);
    } catch (_e) {
      /* noop */
    }
  },
  clear: () => {
    try {
      localStorage.removeItem(TOKEN_KEY);
    } catch (_e) {
      /* noop */
    }
  },
};

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Phase 9 — attach active profile id so /me/* profile-scoped endpoints
  // resolve correctly. Skip explicit override if caller already set it.
  const pid = profileStore.get();
  if (pid && !config.headers["X-Profile-Id"]) {
    config.headers["X-Profile-Id"] = pid;
  }
  return config;
});

// Phase 9 — when the server reports profile_required (400 with that detail),
// punt the user to the storefront's select-profile screen so they can resume
// their session. Skip for non-storefront URLs (admin/studio) since those
// dashboards don't depend on a profile.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (
      err?.response?.status === 400 &&
      detail === "profile_required" &&
      typeof window !== "undefined"
    ) {
      const m = window.location.pathname.match(/^\/s\/([a-z0-9-]+)/i);
      if (m && !window.location.pathname.endsWith("/select-profile")) {
        const next = window.location.pathname + window.location.search;
        window.location.assign(`/s/${m[1]}/select-profile?next=${encodeURIComponent(next)}`);
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" • ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
